import System from './system';
export default {
    namespaced: true,
    modules: {
        System
    }
};
